'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoMicA = function IoMicA(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm8.5 18.6c0-0.8 0.7-1.5 1.6-1.5s1.4 0.7 1.4 1.5v1.1c0 2.2 1 4.1 2.5 5.6s3.5 2.4 5.7 2.4 4.3-0.9 5.8-2.4 2.5-3.4 2.5-5.6v-1.1c0-0.8 0.6-1.5 1.4-1.5s1.6 0.7 1.6 1.5v1.1c0 5.1-3.6 9.4-8.4 10.6-0.1 0-0.3 0.1-0.4 0.1-0.4 0.1-0.7 0.5-0.9 1v4.5c0 0.9-0.7 1.6-1.6 1.6-0.8 0-1.5-0.7-1.5-1.6v-4.5c-0.2-0.5-0.5-0.8-1-1 0 0-0.2-0.1-0.3-0.1-4.8-1.2-8.4-5.5-8.4-10.6v-1.1z m5.2-10.2c0-3.2 2.7-5.9 6.1-5.9s6 2.7 6 5.9v11.3c0 3.3-2.7 5.8-6 5.8s-6.1-2.5-6.1-5.8v-11.3z' })
        )
    );
};

exports.default = IoMicA;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/mic-a.js
// module id = 2380
// module chunks = 0